import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=05e40caa&scoped=true&lang=pug"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNav.vue?vue&type=style&index=0&id=05e40caa&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e40caa",
  null
  
)

export default component.exports